import axios from "axios";
import { toast } from "react-toastify";
import { FtlRouteViewModel } from "../ViewModel/FtlRouteViewModel";
import { combinedUrls } from "../../URL/functions";
import { ftlRouteUrls } from "../../URL/ApplicationUrls";

export const fetchTemplateFtlRoutes = async (
  listOfRouteNumbers: Array<string>
) => {
  const data = { routeNumbers: listOfRouteNumbers };

  const fetchPromise = axios.post(
    combinedUrls(ftlRouteUrls.base.apiUrl, "Templates"),
    data
  );

  const response = await toast.promise(fetchPromise, {
    error: "Error when fetching",
  });
  if (response.status !== 200) {
    throw new Error("Network response was not ok");
  }

  return response.data as Array<FtlRouteViewModel>;
};
